// extracted by mini-css-extract-plugin
export default {"container":"PhotoCarousel_container__54tHi","carousel":"PhotoCarousel_carousel__FGi9m","item":"PhotoCarousel_item__431Ww"};